import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore';
import { restoreSession } from '@/hooks/useAuth';
import { Spinner } from '@/components/ui/Spinner';
import { Button } from '@/components/ui/Button';

export function ProtectedRoute() {
  const status = useAuthStore((state) => state.status);
  const error = useAuthStore((state) => state.sessionError);
  if (status === 'loading') return <div role="status" className="p-8"><Spinner /> Checking session…</div>;
  if (status === 'error') return <div className="p-8"><p role="alert">{error}</p><Button onClick={() => void restoreSession()}>Retry session check</Button></div>;
  if (status === 'unauthenticated') return <Navigate to="/login" replace />;
  return <Outlet />;
}
